import * as queryString from 'querystring'
import React, { useEffect, useRef } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import Scrollbars from 'react-custom-scrollbars'
import { useDispatch } from 'react-redux'
import Notification, {
  DeleteAllButton,
  Loader,
  NotificationLabel,
} from '../../components/Notifications'
import TemplateSendModal from '../BookingCalendar/ReservationModal/TemplateSendModal'
import i18n from '../../i18n'

const NotificationsService = function({
  loadNotifications,
  deleteNotification,
  notifications,
  notRead,
  hasMore,
  location,
  isLoading,
}) {
  const scrollRef: React.RefObject<any> = useRef()
  const dispatch = useDispatch()

  const {
    accessToken,
    height = '100vh',
    minHeight = 0,
    header = 'false',
    lang = 'en',
    modifyDate = 0,
  } = queryString.parse(location.search.replace('?', ''))

  function getScrollParent() {
    return scrollRef.current ? scrollRef.current.view : null
  }

  useEffect(() => {
    dispatch({
      accessToken,
      lang,
      modifyDate,
      type: 'Set notification service state',
    })
    return () => {
      dispatch({ type: 'Set notification service state' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, lang, modifyDate])

  return (
    <div style={{ backgroundColor: 'white' }}>
      {!(header === 'false') && <NotificationLabel count={notRead} />}
      <Scrollbars
        ref={scrollRef}
        autoHeight={true}
        autoHeightMax={`calc(${height ? height : '100vh'} - ${
          header === 'true' ? '100px' : '50px'
        })`}
        autoHeightMin={
          minHeight
            ? `calc(${minHeight} - ${header === 'true' ? '100px' : '50px'})`
            : 0
        }
      >
        <InfiniteScroll
          pageStart={0}
          useWindow={false}
          loadMore={loadNotifications}
          hasMore={!isLoading && hasMore}
          threshold={150}
          getScrollParent={getScrollParent}
          loader={<Loader />}
        >
          {notifications.map(not => (
            <Notification
              key={`notification-${not.id}`}
              deleteNotification={deleteNotification(not.id)}
              notification={not}
            />
          ))}
          {!hasMore && (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                margin: '10px 0px',
              }}
            >
              {i18n.t('BBO_930_thats_all')}
            </div>
          )}
        </InfiniteScroll>
      </Scrollbars>
      <DeleteAllButton
        notRead={notRead}
        deleteAll={deleteNotification('all')}
      />
      <TemplateSendModal />
    </div>
  )
}

export default NotificationsService
